export default "__VITE_ASSET__DXys0CHL__"